(function ($, Drupal, once) {

  Drupal.behaviors.accordionLoadMore = {
    attach(context) {

      once('accordion-load-more', '.paragraph--type--accordion .accordion', context).forEach(function (accordion) {

        const button = accordion.querySelector('.accordion-load-more');

        if (!button) {
          return;
        }

        button.addEventListener('click', function () {

          accordion.querySelectorAll('.d-none').forEach(function (item) {
            item.classList.remove('d-none');
          });

          button.remove();
        });

      });

    }
  };

})(jQuery, Drupal, once);